// extracted by mini-css-extract-plugin
module.exports = {"line":"nakajitsu_line__vwNnc","mobileAppWrapper":"nakajitsu_mobileAppWrapper__10ONw"};